<realwear-cloud-top-bar></realwear-cloud-top-bar>

<div class="shell">
  <realwear-cloud-app-detail [appId]="appId$ | async" (loginRequested)="onLoginRequested()">
  </realwear-cloud-app-detail>
</div>
<realwear-cloud-footer></realwear-cloud-footer>
